'use client';

import { Link } from '@/i18n/navigation';
import clsx from 'clsx';
import { useSearchParams } from 'next/navigation';

type Props = { page: number };

function PaginationLink(props: Props) {
  const { page } = props;
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);
  params.set('page', page.toString());

  const currentPage = searchParams.get('page') ?? '1';
  const isActive = page.toString() === currentPage;

  return (
    <Link
      href={`?${params.toString()}`}
      aria-current={isActive ? 'page' : undefined}
      aria-label={isActive ? `Aktuelle Seite, Seite ${page}` : `Zu Seite ${page} gehen`}
      className={clsx('pagination__link', {
        'pagination__link--active': isActive,
      })}
    >
      {page}
    </Link>
  );
}

export default PaginationLink;
